module.exports = __webpack_public_path__ + "static/media/privacy-policy.72389da1.jpg";